import { render, staticRenderFns } from "./UserReferralItem.vue?vue&type=template&id=3eec380c&scoped=true&"
import script from "./UserReferralItem.vue?vue&type=script&lang=js&"
export * from "./UserReferralItem.vue?vue&type=script&lang=js&"
import style0 from "./UserReferralItem.vue?vue&type=style&index=0&id=3eec380c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eec380c",
  null
  
)

export default component.exports